/* jslint es6 */
import Debounce from "debounce";

function Header() {
    var that = this;
    this.el = document.querySelector('.header');
    this.content = document.querySelector('.wrapper');

    function scroll() {
        if (window.pageYOffset < 100) {
            that.el.classList.remove('is-small');
            that.content.classList.remove('header-is-small');
        } else {
            that.el.classList.add('is-small');
            that.content.classList.add('header-is-small');
        }
    };

    // window.addEventListener('scroll', Debounce(scroll, 10));
    window.addEventListener('scroll', function() {
        scroll();
    });

    if (window.location.hash) {
        this.el.classList.remove('show');
    }
}

export default Header;



// WEBPACK FOOTER //
// ./js/components/header/index.js